import {APIActionStatus, Column, Field, formsStore} from '../../../../stores/Form';

export const handleFormBooleanValue = async (column: Column, currField: Field) => {
    if (!formsStore.currentScreen) return APIActionStatus.blocked;

    // Boolean inputs: ensure focus change completes before value update in the grid. It fixes
    // value change issue, if the user click on input from child subform
    return await formsStore.currentScreen.onFieldFocusChange(
        {
            newRowIndex: column.parentForm.currentRow,
            newCellIndex: column.columnIndex,
            level: column.parentForm.level
        },
        async () => {
            // After focus change completes (including exiting subform),
            // update value and trigger field update
            currField.setCurrentValue(!(currField.currentValue as boolean));
            await formsStore.currentScreen.fieldUpdate(currField);
        }
    );
};
